<template>
  <div v-if="visible" class="position-relative no-print">
    <v-row
      class="position-fixed px-4 py-2 elevation-3 d-flex align-center bg-white"
      style="top: 116px; z-index: 3; transition: 200ms ease;"
      :style="`left: ${widthOffset}px; width: calc(100% - ${widthOffset}px);`"
    >
      <span class="text-subtitle-2 font-weight-medium">
        <slot />
      </span>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
import { useDrawerStore } from '@/stores/drawer'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useDisplay } from 'vuetify/lib/composables/display'

const display = useDisplay()

const drawer = useDrawerStore()

interface Props {
  threshold?: number
}

const { threshold = 80 } = defineProps<Props>()

const visible = ref(false)

// Move TFloatingBar right when TheDrawer is open
const widthOffset = computed(() => {
  if (display.mobile.value) return 25

  return drawer.hovering || drawer.lockedOpen ? 320 : 86
})

function checkVisibility() {
  const scrollY = window.scrollY
  visible.value = scrollY > threshold
}

onMounted(() => {
  window.addEventListener('scroll', checkVisibility, { passive: true })
  checkVisibility()
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', checkVisibility)
})
</script>
